module.exports = __webpack_public_path__ + "img/new-section-white-logo.fa6fd9b5.png";